import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from './globals';
import { FormBuilder, Validators } from '@angular/forms';
import { ExternalOperationCommonSettings } from 'app/models/external-operation-common-settings';

@Injectable({ providedIn: 'root' })
export class ExternalOperationService {

    constructor(private http: HttpClient, private globals: Globals,
                private formBuilder: FormBuilder) {
    }

    externalOperationCommonSettingsFormGroup(commonSettings: ExternalOperationCommonSettings = null) {
        return this.formBuilder.group({
            id: [(commonSettings)? commonSettings.id: undefined],
            scheme: [(commonSettings)? commonSettings.scheme: undefined, Validators.required],
            accepts: [(commonSettings)? commonSettings.accepts: undefined],
            returns: [(commonSettings)? commonSettings.returns: undefined],
            is_per_user_auth: [(commonSettings)? commonSettings.is_per_user_auth || 0: 0, Validators.required],
            connected_app_endpoint: [(commonSettings)? commonSettings.connected_app_endpoint: null, Validators.required],
            auth_methods: [(commonSettings)? commonSettings.auth_methods: []],
            connected_app_endpoint_id: [(commonSettings)? commonSettings.connected_app_endpoint_id: null, Validators.required],
            connected_app_id: [(commonSettings)? commonSettings.connected_app_endpoint.connected_app_id: null, Validators.required],
        });
    }
}